import {ReactNode} from 'react'
import {CSS_CLASSES} from 'slices/AnimatedTextBlock/components/constants'
import {MobileParallaxImageWrapper} from 'slices/AnimatedTextBlock/components/MobileParallaxImageWrapper'
import {getMobileSlot, getLabelNumberParity} from 'slices/AnimatedTextBlock/components/labelUtils'
import {PrismicNode, MobileSlots} from 'slices/AnimatedTextBlock/components/types'
import cn from 'classnames'

export const ParagraphComponent = ({
  children,
  node,
  mobileSlots,
}: {
  children: ReactNode
  node: PrismicNode
  mobileSlots?: MobileSlots
}) => {
  const label = node?.spans?.[0]?.data?.label
  const slot = getMobileSlot(label, mobileSlots)
  const numberParity = getLabelNumberParity(label)

  return (
    <div
      data-paragraph
      className={cn({
        'lg:hidden': slot,
      })}
    >
      {!slot && <p className={`${CSS_CLASSES.PARAGRAPH} lg:leading-[34px]`}>{children}</p>}
      {slot && (
        <MobileParallaxImageWrapper
          className={cn(CSS_CLASSES.MOBILE_OVERLAY, 'my-8 md:max-lg:justify-self-center', {
            'max-md:float-end': numberParity === 'odd',
          })}
        >
          {slot.src}
        </MobileParallaxImageWrapper>
      )}
    </div>
  )
}
